<template>
  <div class="req-report-applicants-loader">
    <WidgetHeaderSkeleton />
    <div class="req-report-applicants-loader-wrapper">
      <div class="top-row">
        <div class="top-row-two-items">
          <div class="top-row-rectangle rect-left" />
          <v-skeleton-loader type="heading" width="114" />
        </div>
        <div class="top-row-one-item" />
        <div class="top-row-two-items">
          <div class="top-row-rectangle rect-right" />
          <v-skeleton-loader type="heading" width="114" />
        </div>
      </div>
      <div class="bottom-row">
        <v-skeleton-loader type="heading" width="60" />
        <div v-for="item in 3" :key="item" class="bottom-row-item" />
      </div>
    </div>
  </div>
</template>

<script setup>
import WidgetHeaderSkeleton from '@/components/insights/skeletonLoaders/WidgetHeaderSkeleton.vue';
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader__heading) {
  margin: 0px;
}

:deep(.v-skeleton-loader__text) {
  margin: 0px;
}

.req-report-applicants-loader {
  background: @white;
  padding: 24px;
  border-radius: 10px;
}

.req-report-applicants-loader-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.top-row {
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: flex-end;

  .top-row-one-item {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: @grey-400;
    align-self: center;
  }

  .top-row-two-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .top-row-rectangle {
    width: 62px;
    background: @grey-500;
    border-radius: 4px;
    height: 24px;
  }

  .rect-right {
    height: 48px;
  }
}

.bottom-row {
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-top: 50px;

  :deep(.v-skeleton-loader__heading) {
    height: 32px;
    border-radius: 8px;
  }

  .bottom-row-item {
    border: 1px solid @stroke-default;
    border-radius: 8px;
    width: 60px;
  }
}
</style>
